/* eslint-disable import/prefer-default-export */
import axios from 'axios';

const API_HOST = process.env.REACT_APP_API_BASE_PATH;

export const getBankListData = params =>
  axios.get(`${API_HOST}/bank`, {
    params,
    withCredentials: true
  });

export const getBankBranchListData = params =>
  axios.get(`${API_HOST}/bank-branch`, {
    params,
    withCredentials: true
  });
